"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomRubricSerializer = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
class CustomRubricSerializer extends dp_http_client_lib_1.PageableSerializer {
    serializeOne(data) {
        return {
            id: data.id,
            name: data.name,
            curriculum: data.curriculum,
            grade: data.grade,
            type: data.type,
            module: data.module,
            rubric: {
                ratings: this.serializeRatings(data.rubric?.ratings),
                categories: this.serializeCategories(data.rubric?.categories),
            },
            status: data.status,
            scoringType: data.scoringType,
        };
    }
    serializeRatings(ratings) {
        if (!Array.isArray(ratings))
            return [];
        return ratings.map((rating) => ({
            id: rating.id,
            description: rating.description,
            proficiency: rating.proficiency,
            maxScorePercentageValue: rating.maxScorePercentageValue,
        }));
    }
    serializeCategories(categories) {
        if (!Array.isArray(categories))
            return [];
        return categories.map((category) => ({
            id: category.id,
            name: category.name,
            weight: category.weight,
            default: category.default,
            criteria: this.serializeCriteria(category.criteria),
        }));
    }
    serializeCriteria(criteria) {
        if (!Array.isArray(criteria))
            return [];
        return criteria.map((criterion) => ({
            id: criterion.id,
            standards: criterion.standards,
            description: criterion.description,
            score: criterion.score,
        }));
    }
}
exports.CustomRubricSerializer = CustomRubricSerializer;
//# sourceMappingURL=custom-rurbic.serializer.js.map